import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FormCaption, InformSpan } from '../../common/components';
import { ROUTER_LINKS } from '../../common/consts/app-keys.const';

export const PasswordUpdated = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col justify-center">
      <FormCaption>{t('auth.passwordUpdatedTitle')}</FormCaption>
      <InformSpan>
        {t('auth.passwordUpdatedSubtitle')}
      </InformSpan>
      <button
        type="button"
        onClick={() => navigate(ROUTER_LINKS.SIGNIN)}
        className="w-[301px] md:w-[392px] h-[52px] bg-base-black text-white dark:bg-[#C8C8CB] dark:text-[#1C1C1F] rounded-[32px] font-body text-[16px] font-medium hover:bg-[#2E2E30] dark:hover:bg-[#D8D8DB] transition-all duration-200 mx-auto"
      >
        {t('auth.loginButton')}
      </button>
    </div>
  );
};
